export const isChromeVersionUpToDate = (
  higherThanVersionId: number[],
  versionId: string,
) => {
  const userChromeExtensionsVersionAsArray = versionId?.split(".");

  let isChromeVersionUpdated = !!versionId;

  if (userChromeExtensionsVersionAsArray) {
    for (let index = 0; index < higherThanVersionId.length; index++) {
      const currentVersion = higherThanVersionId[index];
      const extensionVersion = parseInt(
        userChromeExtensionsVersionAsArray[index] || "0",
      );

      if (extensionVersion > currentVersion) {
        break; // The extension version is greater at a higher significance level, so stop checking
      } else if (extensionVersion < currentVersion) {
        isChromeVersionUpdated = false; // The extension version is lesser, set flag to false
        break; // No need to check further as we found a lower segment
      }
      // If they are equal, continue to the next segment
    }
  }
  return isChromeVersionUpdated;
};
